<template>
  <div
    v-if="processedText"
    v-html="processedText"
    class="fw-300 richtext"
    :class="text"
  />
</template>
<script>

export default {
  name: "",
  props: {
    text: {
      type: String,
      default() {
        return "";
      },
    },
    textColor: {
      type: String,
      default() {
        return "var(--neutral-400)";
      },
    },
    classes: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {};
  },
  computed: {


    processedText() {
      if (!this.text) return "";

      let html = this.text;
      //
      html = html.replace(/<p>\s*<\/p>/gi, "<br>");
      const pAtEnd = html.match(/(<br\s*\/?>|\s*)$/gi)
        ? 0
        : html.match(/(<br\s*\/?>)/gi)?.length || 0;
      let finalPs = html.match(/(<br\s*\/?>\s*){1,2}$/i);

      if (finalPs) {
        const count = (finalPs[0].match(/<br\s*\/?>/gi) || []).length;
        if (count === 1) {
          html = html.replace(/(<br\s*\/?>\s*)$/i, "");
        } else if (count === 2) {
          html = html.replace(/(<br\s*\/?>\s*){2}$/i, "<br>");
        }
      }
      html = html.replace(/custom-cta-button/g, "btn btn-primary arrow");

      return html;
    },
  },
};
</script>
<style scoped>
p {
  color: v-bind(textColor);
}
</style>
